var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "detail-right" },
    [
      _c(
        "p",
        {
          staticClass: "right_1 show-more-ticket-right-field hover-shadow",
          attrs: { title: "管理员可通过 设置 > 界面组件 配置默认展示哪些内容" },
          on: { click: _vm.showMoreTicketField }
        },
        [_vm._v("其他工单属性(已折叠,点击可展开)")]
      ),
      _vm._v(" "),
      _c("LinkedTicketList", { attrs: { ticketNo: _vm.ticketEntity.orderId } }),
      _vm._v(" "),
      _c("p", { staticClass: "RightMerchantOrder" }, [
        _c("span", [
          _c(
            "a",
            {
              attrs: { title: "点击跳转到订单详情页" },
              on: { click: _vm.goOrder }
            },
            [_c("b", { staticClass: "strong" }, [_vm._v("订单")])]
          ),
          _vm._v(" "),
          _c(
            "a",
            {
              staticStyle: { color: "#5b7e94", "font-size": "12px" },
              attrs: { title: "点击复制订单信息" },
              on: { click: _vm.doCopyOrder }
            },
            [_vm._v("复制")]
          ),
          _vm._v(" "),
          _c(
            "a",
            {
              staticStyle: { color: "#5b7e94", "font-size": "12px" },
              attrs: { title: "点击跳转到招募需求页" },
              on: { click: _vm.goRecruit }
            },
            [_vm._v("招募")]
          ),
          _vm._v(" "),
          _c(
            "a",
            {
              staticStyle: { color: "#5b7e94", "font-size": "12px" },
              attrs: { title: "点击跳转到人员初筛页" },
              on: { click: _vm.goPeople }
            },
            [_vm._v("人员")]
          ),
          _vm._v(" "),
          _c(
            "a",
            {
              staticStyle: { color: "#5b7e94", "font-size": "12px" },
              attrs: { title: "点击跳转到培训计划页" },
              on: { click: _vm.goStudy }
            },
            [_vm._v("培训")]
          )
        ])
      ]),
      _vm._v(" "),
      _c(
        "p",
        { staticClass: "RightMerchantOrder" },
        [
          _c("MerchantOrderSearch", {
            ref: "ticket_order_18",
            attrs: { css: "width:100%", id: _vm.ticketEntity.merchantOrderId },
            on: { change: _vm.updateMerchantOrderId }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "p",
        {
          staticClass: "RightMerchant",
          attrs: { title: "在框中输入名字可搜索并修改" }
        },
        [
          _c("span", { staticClass: "strong" }, [_vm._v("商家")]),
          _vm._v(" "),
          _c(
            "a",
            {
              staticStyle: { color: "#5b7e94", "font-size": "12px" },
              attrs: { title: "点击复制商家信息" },
              on: { click: _vm.doCopyMerchant }
            },
            [_vm._v("复制")]
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "p",
        { staticClass: "RightMerchant" },
        [
          _c("MerchantSearch", {
            ref: "ticket_MerchantSearch_24",
            attrs: { css: "width:100%", id: _vm.ticketEntity.merchantId },
            on: { change: _vm.updateMerchantId }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "p",
        {
          staticClass: "RightShop",
          attrs: { title: "在框中输入名字可搜索并修改" }
        },
        [
          _c("span", { staticClass: "strong" }, [_vm._v("店铺")]),
          _vm._v(" "),
          _c(
            "a",
            {
              staticStyle: { color: "#5b7e94", "font-size": "12px" },
              attrs: { title: "点击复制店铺信息" },
              on: { click: _vm.doCopyShop }
            },
            [_vm._v("复制")]
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "p",
        { staticClass: "RightShop" },
        [
          _c("TicketFormShop", {
            ref: "TicketFormShop_58",
            staticStyle: { width: "100%" },
            on: { change: _vm.onShopChange },
            model: {
              value: _vm.ticketEntity.shopId,
              callback: function($$v) {
                _vm.$set(_vm.ticketEntity, "shopId", $$v)
              },
              expression: "ticketEntity.shopId"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "p",
        [
          _c(
            "el-popover",
            { attrs: { width: "450", placement: "left", trigger: "hover" } },
            [
              _c("span", [_vm._v("点击输入框, 然后点击其他位置, 以提交修改")]),
              _vm._v(" "),
              _c("span", { attrs: { slot: "reference" }, slot: "reference" }, [
                _c("span", { staticClass: "strong" }, [_vm._v("工时(小时)")]),
                _vm._v(" "),
                _c("span", { staticStyle: { "font-size": "10px" } }, [
                  _vm._v("?")
                ])
              ])
            ]
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "p",
        [
          _c("el-input-number", {
            attrs: {
              placeholder: "点我, 然后点其他地方, 以提交",
              precision: 1,
              min: 0
            },
            on: { blur: _vm.onWorkHourChange },
            model: {
              value: _vm.ticketEntity.workHour,
              callback: function($$v) {
                _vm.$set(_vm.ticketEntity, "workHour", $$v)
              },
              expression: "ticketEntity.workHour"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _vm._m(0),
      _vm._v(" "),
      _c(
        "p",
        [
          _c("el-date-picker", {
            staticStyle: { width: "100%" },
            attrs: {
              "picker-options": _vm.datePickerOptions,
              placeholder: "工单开始时间",
              "popper-class": "popper_class_0",
              type: "datetime"
            },
            on: { change: _vm.onStartAtChange },
            model: {
              value: _vm.ticketEntity.startAt,
              callback: function($$v) {
                _vm.$set(_vm.ticketEntity, "startAt", $$v)
              },
              expression: "ticketEntity.startAt"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _vm._m(1),
      _vm._v(" "),
      _c(
        "p",
        { staticClass: "RightEndAt" },
        [
          _c("el-date-picker", {
            staticStyle: { width: "100%" },
            attrs: {
              "picker-options": _vm.datePickerOptions,
              placeholder: "工单截止时间",
              "popper-class": "popper_class_0",
              type: "datetime"
            },
            on: { change: _vm.onEndAtChange },
            model: {
              value: _vm.ticketEntity.endAt,
              callback: function($$v) {
                _vm.$set(_vm.ticketEntity, "endAt", $$v)
              },
              expression: "ticketEntity.endAt"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _vm._m(2),
      _vm._v(" "),
      _c(
        "p",
        [
          _c("TicketProjectSelect", {
            staticStyle: { width: "100%" },
            attrs: { ticketNo: _vm.ticketEntity.orderId },
            on: { change: _vm.onTicketProjectChange }
          })
        ],
        1
      ),
      _vm._v(" "),
      _vm._m(3),
      _vm._v(" "),
      _c("CustomerScheduleInfo", {
        staticClass: "RightCustomerSchedule",
        attrs: {
          customerId: _vm.ticketEntity.creatorId,
          scheduleTime: _vm.ticketEntity.createdAt
        }
      }),
      _vm._v(" "),
      _vm._m(4),
      _vm._v(" "),
      _c(
        "p",
        { staticClass: "RightCallInfo" },
        [
          _c("TicketWidgetCallInfo", {
            model: {
              value: _vm.ticketEntity.callId,
              callback: function($$v) {
                _vm.$set(_vm.ticketEntity, "callId", $$v)
              },
              expression: "ticketEntity.callId"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c("p", { staticClass: "RightWorkflow" }, [
        _c("span", { staticClass: "strong" }, [_vm._v("工作流")]),
        _vm._v(" "),
        _c(
          "a",
          {
            staticStyle: { float: "right", "margin-right": "10px" },
            attrs: {
              title: "查看工作流",
              target: "_blank",
              href:
                "/ticket/activiti_model_viewer?modelId=" +
                _vm.ticketEntity.workflowId +
                "&ticketNo=" +
                _vm.ticketEntity.orderId
            }
          },
          [_vm._v("预览")]
        )
      ]),
      _vm._v(" "),
      _c(
        "p",
        { staticClass: "RightWorkflow" },
        [
          _c("TicketWorkflowSelect", {
            attrs: { value: _vm.ticketEntity.workflowId }
          }),
          _vm._v(" "),
          _vm.ticketEntity.workflowId
            ? _c("WorkflowGraph", {
                ref: "workflowGraph",
                attrs: {
                  workflowId: _vm.ticketEntity.workflowId,
                  ticketNo: _vm.ticketEntity.orderId
                }
              })
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _c("TicketWidgetGroup", {
        staticStyle: { width: "100%" },
        attrs: { group: "AfterTicketDetailRight" }
      }),
      _vm._v(" "),
      _c("div", { staticStyle: { height: "50px" } })
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _c("span", { staticClass: "strong" }, [_vm._v("开始时间")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", { staticClass: "RightEndAt" }, [
      _c("span", { staticClass: "strong" }, [_vm._v("截止时间")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [_c("span", { staticClass: "strong" }, [_vm._v("项目")])])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", { staticClass: "RightCustomerSchedule" }, [
      _c("span", { staticClass: "strong" }, [_vm._v("客服(排班) 信息")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", { staticClass: "RightCallInfo" }, [
      _c("span", { staticClass: "strong" }, [_vm._v("语音呼叫信息")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-003d7968", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-003d7968","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ticket/TicketDetailRight.vue
// module id = 736
// module chunks = 75